import { FeatureCollection, MultiPolygon, Point, Polygon } from 'geojson'

export enum DraftRequestReviewStatus {
  PENDING = 'pending_review',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  FLAGGED = 'flagged',
}

export enum DraftRequestReviewAction {
  APPROVE = 'approve',
  REJECT = 'reject',
  FLAG = 'flag',
}

export enum DraftDistributionType {
  GPS = 'gps',
  WEBSITE = 'website',
  SECRET = 'secret',
  CODES = 'codes',
  EXPRESS = 'express',
}

export interface DraftReview {
  id: number
  draftId: number
  status: DraftRequestReviewStatus
  comment: string
  reviewedBy: string
  reviewedAt: Date
  createdAt: Date
  updatedAt: Date
}

export interface Draft {
  id: number
  createdAt: Date
  updatedAt: Date
  status: DraftRequestReviewStatus
  userId: string
  data: DraftData
  dropId: number | null
  deletedAt: Date | null
  recentReviews?: DraftReview[]
  issuerEmail?: string
}

export interface DraftData {
  title: string
  description: string
  eventUrl: string | null
  startDate: Date
  endDate: Date | null
  timezone: string
  image: DraftImage
  cropImage: DraftImage
  mintingConfiguration: DraftMintingConfiguration
  distribution: DraftDistribution
}

export interface DraftImage {
  url: string
  mimeType: string
  fileName: string
}

export interface DraftMintingConfiguration {
  supply: number
  blockchainId: number
}

export type GpsDistributionGeoJson = FeatureCollection<Point | Polygon | MultiPolygon, { radius?: number }>

export interface DraftGpsDistribution {
  startDate: Date | null
  endDate: Date | null
  geoJson: GpsDistributionGeoJson | null
}

export interface DistributionWebsiteDraft {
  startDate: Date | null
  endDate: Date | null
  name: string | null
}

export interface DistributionSecretDraft {
  startDate: Date | null
  endDate: Date | null
  name: string | null
}

export interface DistributionExpressDraft {
  id: string
  draftId: number
  websiteName: string
}

export type DraftDistribution =
  | {
      type: DraftDistributionType.CODES
      gps: DraftGpsDistribution | null
      website: DistributionWebsiteDraft | null
      secret: DistributionSecretDraft | null
      express: null
    }
  | {
      type: DraftDistributionType.GPS
      gps: DraftGpsDistribution
      website: DistributionWebsiteDraft | null
      secret: DistributionSecretDraft | null
      express: null
    }
  | {
      type: DraftDistributionType.WEBSITE
      gps: DraftGpsDistribution | null
      website: DistributionWebsiteDraft
      secret: DistributionSecretDraft | null
      express: null
    }
  | {
      type: DraftDistributionType.SECRET
      gps: DraftGpsDistribution | null
      website: DistributionWebsiteDraft | null
      secret: DistributionSecretDraft
      express: null
    }
  | {
      type: DraftDistributionType.EXPRESS
      gps: null
      website: null
      secret: null
      express: DistributionExpressDraft
    }

export interface PaginatedResponse<T> {
  items: T[]
  total: number
  limit: number
  offset: number
}
